export default {"src":"/_next/static/media/sbd.f3d55532.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};